import PropTypes from 'prop-types';
import React, { memo } from 'react';

import { CARD_HEADER_SIZE } from './constants';
import { CardHeaderContainer, CardTitle } from './styles';

const CardHeader = ({
  avatar = null,
  title,
  action,
  size = CARD_HEADER_SIZE.SMALL,
  ...props
}) => (
  <CardHeaderContainer {...props}>
    <CardTitle $size={size}>
      {avatar}
      {title}
    </CardTitle>
    {action}
  </CardHeaderContainer>
);

CardHeader.propTypes = {
  avatar: PropTypes.node,
  title: PropTypes.node,
  action: PropTypes.node,
  size: PropTypes.oneOf(Object.values(CARD_HEADER_SIZE)),
};

export default memo(CardHeader);
